import styled from 'styled-components'

export const TextAreaContainer = styled.div``

export const TextAreaLabelContainer = styled.div`
  position: relative;
`

export const TextAreaLabel = styled.p`
  position: absolute;
  margin: 0;
  top: -8px;
  box-sizing: border-box;
  padding: 0px 5px;
  left: 8px;
  font-weight: 600;
  font-size: 13px;
  background: ${({ theme }) => theme.colors.backgroundPrimary};
  z-index: 14;
`

export const TextAreaSpan = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`
export const TextAreaStyled = styled.textarea<{ size: number }>`
  width: 100%;
  background: ${({ theme }) => theme.colors.white};
  box-sizing: border-box;
  padding: 10px 18px;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: 8px;
  font-size: 16px;
  letter-spacing: -0.36px;
  min-height: ${({ size }) => size}px;
  color: ${({ theme }) => theme.colors.fontMain};
  font-family: sans-serif;
  :focus {
    outline: none !important;
  }
`

export const TextAreaStyledContainer = styled.div`
  position: relative;
`
export const TextAreaCharacter = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
`
